<div class="dialog-header">
  <h6 matDialogTitle>SSO Login</h6>
  <button
    id="closebtn"
    class="close-button"
    mat-icon-button
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">SSO ID</mat-label>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
        <mat-form-field>
          <input
            matInput
            name="username"
            formControlName="userNameCtr"
            [(ngModel)]="model.userName"
            required
          />
          <mat-error
            *ngIf="this.formData.get('userNameCtr').hasError('required')"
            >SSOID is required</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">SSO Password</mat-label>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
        <mat-form-field>
          <input
            type="password"
            matInput
            name="password"
            formControlName="passwordCtr"
            [(ngModel)]="model.password"
            required
          />

          <mat-error
            *ngIf="this.formData.get('passwordCtr').hasError('required')"
            >Password is required</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <div class="pull-right" style="margin-top: 1em">
    <button
      id="loginbtn"
      type="button"
      bciprimarybutton
      class="button-primary"
      [disabled]="!formData.valid"
      (click)="login()"
    >
      Login
    </button>
    &nbsp;
    <button
      id="cancelbtn"
      type="button"
      bciprimarybutton
      class="button-primary"
      (click)="close(false)"
    >
      Cancel
    </button>
  </div>
</mat-dialog-footer>
